module.exports = __webpack_public_path__ + "img/Pic_WGM_LB_e.6efecbc6.gif";